import { User } from "@/types/user";
import axios, { AxiosResponse } from "axios";
import api from "./api";

export const getUser = async (token: string | null): Promise<AxiosResponse<User>> => {
  try {
    if (!token) {
      throw new Error("User is not authenticated");
    }

    const response = await api.get(`/auth/users/me/`, {
      headers: {
        Authorization: `JWT ${token}`,
      },
    });

    return response;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      throw new Error(error.response?.data.detail || "Failed to fetch user");
    } else {
      throw new Error("An unexpected error occurred");
    }
  }
};

export const updateGreeted = async (): Promise<void> => {
  // api instance already includes base `/api` and Authorization header (set in AuthContext)
  await api.post(`/auth/users/update-greeted/`, {});
};
